import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const FilterContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '12px',
  marginBottom: '24px',
  flexWrap: 'wrap',
}));

const FilterButton = styled('button')(({ active }) => ({
  padding: '8px 16px',
  borderRadius: '20px',
  border: 'none',
  background: active ? '#EDAFB8' : '#F7E1D7',
  color: active ? 'white' : '#333A3B',
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  fontWeight: 500,
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
}));

export default function FilterBar({ 
  filter, 
  setFilter, 
  totalJuzs,
  completedJuzs,
  selectedJuzs 
}) {
  const filters = [
    { id: 'all', label: `Tümü (${totalJuzs})` },
    { id: 'available', label: `Müsait (${totalJuzs - completedJuzs - selectedJuzs})` },
    { id: 'selected', label: `Seçilenler (${selectedJuzs})` },
    { id: 'completed', label: `Tamamlananlar (${completedJuzs})` },
  ];

  return (
    <FilterContainer>
      {filters.map(({ id, label }) => (
        <FilterButton
          key={id}
          active={filter === id}
          onClick={() => setFilter(id)}
        >
          {label}
        </FilterButton>
      ))}
    </FilterContainer>
  );
} 